import { render, staticRenderFns } from "./index-v1.vue?vue&type=template&id=3951ffc6&scoped=true"
import script from "./index-v1.vue?vue&type=script&lang=js"
export * from "./index-v1.vue?vue&type=script&lang=js"
import style0 from "./index-v1.vue?vue&type=style&index=0&id=3951ffc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951ffc6",
  null
  
)

export default component.exports